module.exports = __webpack_public_path__ + "img/cp-map-marker.4bf068b3.svg";